<template>
	<div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery :formdata="getBase" :value="orderSurfaceInfo"></compFormQuery>
		</compWrapper>
		<compWrapper title="发货信息" theme="primary">
			<compFormQuery v-if="query||isCalculated||isPushError" :formdata="getShipAddress" :value="orderSurfaceShip"></compFormQuery>
			<compFormEdit
				v-else
				class="margin-top-15 margin-right-15"
				:formdata="getShipAddress"
				ref="shipAddress"
				v-model="orderSurfaceShip"
			></compFormEdit>
		</compWrapper>
		<compWrapper title="收货信息" theme="primary">
			<compFormQuery
				v-if="query||isCalculated||!isPushError"
				:formdata="getReceiverAddress"
				:value="orderSurfaceReceive"
			></compFormQuery>
			<compFormEdit
				v-else
				class="margin-top-15 margin-right-15"
				:formdata="getReceiverAddress"
				ref="receiverAddress"
				v-model="orderSurfaceReceive"
			></compFormEdit>
		</compWrapper>
		<compWrapper title="包裹信息" theme="info">
			<compPackages
				:query="query||isCalculated"
				ref="packages"
				:datainfo="orderSurfacePackage"
				:datalist="orderSurfacePackageList"
			></compPackages>
		</compWrapper>
		<compWrapper title="其它信息" theme="info">
			<vForm :label-width="120" class="margin-top-10 clearfix">
				<vFormItem label="备注" class="width-50per">
					<div v-if="query">{{otherInfo.remark}}</div>
					<vTextarea v-else v-model="otherInfo.remark" rows="5"/>
				</vFormItem>
			</vForm>
		</compWrapper>
		<div v-if="!query" class="margin-bottom-15">
			<vButton theme="success" class="margin-right-15" @click="submitCalculate">运费测算</vButton>
			<vButton theme="warning" @click="clearCalculate">清空测算</vButton>
		</div>
		<compWrapper title="承运商信息" theme="info" v-if="query">
			<compFormQuery :formdata="getCarrier" :value="orderSurfaceCarrier"></compFormQuery>
		</compWrapper>
		<compLog :data="opLogList" wrapper v-if="query && !activeids">
			<template slot="footer">
				<vButton
					v-if="orderSurfaceInfo.errorStatus==0&&orderSurfaceInfo.orderStatus!=0"
					class="margin-right-15"
					theme="success"
					@click="printSfp"
				>打印面单</vButton>
				<vButton
					v-if="orderSurfaceInfo.errorStatus>0"
					class="margin-right-15"
					theme="primary"
					@click="submitRetrySfp"
				>重试</vButton>
				<vButton
					v-if="orderSurfaceInfo.errorStatus>0"
					class="margin-right-15"
					theme="info"
					@click="submitIgnoreSfp"
				>忽略</vButton>
				<vButton class="margin-right-15" @click="handleGoback">返回</vButton>
			</template>
		</compLog>
		<compWrapper v-if="showCalculateTable" title="请选择承运商及服务" theme="success" :expand="false">
			<compWrapper
				v-for="(item,index) in calculateList"
				class="margin-15"
				:key="index"
				:title="'包裹'+(index+1)"
			>
				<compPackagesize :data="item"></compPackagesize>
				<vTableSimple
					:style="handleCalculateTableStyle"
					:columns="columns"
					:data="handleSortCarrier(item.orderSurfaceCarrierList)"
					size="small"
					border
					stripe
					@on-radio-change="(a,b,c)=>handleSelectedData(a,b,c,index)"
				></vTableSimple>
				<vTableSimple
					v-if="isSplit"
					style="margin:0 15px;width:30%;display:inline-block;"
					:columns="skuColumns"
					:data="[item]"
					size="small"
					border
					stripe
				></vTableSimple>
			</compWrapper>
		</compWrapper>
		<div v-if="!query" class="text-right margin-bottom-15">
			<vButton class="margin-right-15" theme="primary" @click="confirmSubmit('save')">保存</vButton>
			<vButton v-if="!isPushError" class="margin-right-15" theme="error" @click="confirmSubmit('buy')">购买面单</vButton>
			<vButton
				v-if="orderSurfaceInfo.errorStatus!=1"
				class="margin-right-15"
				theme="info"
				@click="submitSave('retry',[])"
			>重试</vButton>
			<vButton class="margin-right-15" @click="handleGoback">返回</vButton>
		</div>
		<compLog :data="opLogList" wrapper v-if="activeids"></compLog>
		<div v-if="activeids" class="text-right">
			<vButton
				v-if="orderSurfaceInfo.errorStatus==0&&orderSurfaceInfo.orderStatus!=0"
				class="margin-right-15"
				theme="success"
				@click="printSfp"
			>打印面单</vButton>
			<vButton
				v-if="orderSurfaceInfo.errorStatus>0"
				class="margin-right-15"
				theme="primary"
				@click="submitRetrySfp"
			>重试</vButton>
			<vButton
				v-if="orderSurfaceInfo.errorStatus>0"
				class="margin-right-15"
				theme="info"
				@click="submitIgnoreSfp"
			>忽略</vButton>
			<vButton @click="comclose">关闭</vButton>
		</div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpSfp, HttpCalculateSfp, HttpUpdateSfp, HttpIgnoreSfp, HttpRetrySfp, HttpUpdateSfpStatus, HttpSfpTrackingNo } from "@/service/sfp/sfp";
import { HttpAllotAddress } from '@/service/boss/dictionary';
import compTrackingno from "./trackingno";
export default {
	props:['activeids','querytype'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compPackages: () => import("./packages"),
		compPackagesize: () => import("../calculation/packagesize"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			isCalculated: false,
			isSplit: false,
			query: false,
			orderSurfaceInfo: {
				errorStatus:null,
			},
			orderSurfaceShip: {},
			orderSurfaceReceive: {},
			orderSurfacePackageList: [],
			orderSurfacePackage: {},
			orderSurfaceCarrier: {},
			otherInfo: {},
			opLogList: [],
			calculateList: [],
			trackingNoData: {},
		};
	},
	created() {
		if(this.activeids){
			this.id = this.activeids
			this.type = this.querytype
		}else{
			this.id = this.id
			this.type = this.type
		}
		this.query = this.type === "query";
		this.orderSurfaceCarrierList = {};
		this.getDetail();
	},
	computed: {
		...mapState("boss", ["accounts"]),
		...mapGetters('boss', ['otherWarehouses']),
		...mapGetters("common", ["getStateList"]),
		isPushError() {
			return this.orderSurfaceInfo.errorStatus == 3
		},
		showCalculateTable() {
			return !this.query && this.calculateList && this.calculateList.length;
		},
		handleCalculateTableStyle() {
			return this.isSplit ? 'margin:0 15px;width:60%;display:inline-block;' : 'margin:0 15px;'
		},

		getReceiverAddress() {
			return [{
				label: "国家",
				key: "receiveCountry",
				tag: "vSelect",
				options: [{
					value: "US"
				},
				{
					value: "ES"
				},
				{
					value: "DE"
				},
				{
					value: "JP"
				}
				]
			},
			{
				label: "州",
				key: "receiveState",
				show: this.orderSurfaceReceive.receiveCountry === "US",
				props: {
					filterable: true
				},
				options: this.getStateList.map(item => {
					return {
						value: item,
						label: item
					};
				})
			},
			{
				label: "州",
				key: "receiveState",
				show: this.orderSurfaceReceive.receiveCountry !== "US"
			},
			{
				label: "城市",
				key: "receiveCity"
			},
			{
				label: "地址",
				key: "receiveAddress1"
			},
			{
				label: "邮编",
				key: "receivePostal"
			},
			{
				label: "电话",
				key: "receiveMobile"
			},
			{
				label: "联系人",
				key: "receiveContact"
			},
			{
				label: "地址2",
				key: "receiveAddress2",
				required: false
			}
			];
		},
		getBase() {
			return [{
				label: "面单ID",
				key: "surfaceId",
				render: (h) => {
					let data = {
						1: '购买异常',
						2: '取消异常',
						3: '推送异常',
						4: '更新异常',
					},
						{ surfaceId, errorStatus } = this.orderSurfaceInfo;
					errorStatus = data[errorStatus];
					return errorStatus ? <div>{surfaceId}<span class='color-error margin-left-5' style='border:1px solid;padding:0 5px;'> {errorStatus}</span></div> : surfaceId
				}
			},
			{
				label: "平台订单号",
				// key: "orderNo",
				render:(h)=>{
                    return <a onClick={this.handleOperates.bind(this,this.otherInfo.orginOrderId,'query')}>{this.orderSurfaceInfo.orderNo}</a>
                }
			},
			{
				label: "店铺账号",
				key: "sourceChannel",
				valueText: (
					this.accounts.find(item => {
						return (
							this.orderSurfaceInfo.sourceChannel == item.id
						);
					}) || {}
				).title
			}
			];
		},
		getShipAddress() {
			return [{
				label: "仓库名称",
				key: "orgWarehouseId",
				tag: "vSelect",
				render: (h) => {
					let orgWarehouseId = this.orderSurfaceShip.orgWarehouseId, orgWarehouse = this.otherWarehouses.find(item => {
						return item.id == orgWarehouseId
					}) || {};
					return `${orgWarehouse.code}(${orgWarehouse.title})`;
				},
				options: this.otherWarehouses.map(item => {
					return {
						value: item.id,
						label: `${item.code}(${item.title})`
					};
				}),
				props: {
					filterable: true
				},
				on: {
					'on-change': this.getAddress
				},
			},
			{
				label: "国家",
				key: "shipCountry",
				tag: "vSelect",
				options: [{
					value: "US"
				},
				{
					value: "ES"
				},
				{
					value: "DE"
				},
				{
					value: "JP"
				}
				]
			},
			{
				label: "州",
				key: "shipState",
				show: this.orderSurfaceShip.shipCountry === "US",
				props: {
					filterable: true
				},
				options: this.getStateList.map(item => {
					return {
						value: item,
						label: item
					};
				})
			},
			{
				label: "州",
				key: "shipState",
				show: this.orderSurfaceShip.shipCountry !== "US"
			},
			{
				label: "城市",
				key: "shipCity"
			},
			{
				label: "邮编",
				key: "shipPostal"
			},
			{
				label: "电话",
				key: "shipMobile"
			},
			{
				label: "联系人",
				key: "shipContact"
			},
			{
				label: "地址",
				key: "shipAddress"
			}
			];
		},
		getCarrier() {
			return [{
				label: "承运商",
				key: "carrierCode"
			},
			{
				label: "承运商服务",
				key: "carrierService"
			},
			{
				label: "预估运费(USD)",
				key: "estimateCost"
			},
			{
				label: "追踪号",
				key: "trackingNo",
				render: (h) => {
					const trackingNo = this.orderSurfaceCarrier.trackingNo, trackingNoData = this.trackingNoData;
					return trackingNoData.trackingDetails ? h('vTooltip', {
						attrs: {
							popperStyle: 'max-width:unset;padding:0;'
						},
						scopedSlots: {
							content: () => h(compTrackingno, { props: { data: trackingNoData } })
						},
					}, trackingNo) : trackingNo
				}

			}
			];
		},
		columns() {
			return [{
				type: "selection",
				isRadio: true,
				width: 60,
				align: "center"
			},
			{
				title: "承运商",
				key: "carrierCode"
			},
			{
				title: "承运商服务",
				key: "carrierService"
			},
			{
				title: "预估费用（USD）",
				key: "estimateCost"
			}
			];
		},
		skuColumns() {
			return [
				{
					title: "ERP SKU",
					key: "erpSku"
				},
				{
					title: "Seller SKU",
					key: "sellerSku"
				},
				{
					title: "订单数量",
					key: "orderQty"
				}
			];
		},
	},
	methods: {
		comclose(){
			this.$emit('on-close')
		},
		handleOperates(params = "", type, batch){
            // console.log(type,params)
            switch(type){
                case 'query':
                    const url = this.$router.resolve({
                        name: 'b2cOrderupdate',
                        params: { type: 'query' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
		handleSortCarrier(data = []) {
			return data.map(function (item) {
				return {
					...item,
					estimateCost: Number(item.estimateCost || 0).toFixed(2)
				}
			}).sort(function (pre, cur) {
				return pre.estimateCost - cur.estimateCost;
			})
		},
		handleGoback() {
			this.$router.push({
				name: "sfpList"
			});
		},
		handleSelectedData(data, val, options = {}, index) {
			const { status, value } = options;
			this.orderSurfaceCarrierList[value + '&' + index] = status ? data : undefined;
		},
		handleResponse(data = {}) {
			this.orderSurfaceInfo = data.orderSurfaceInfo;
			this.orderSurfaceShip = data.orderSurfaceShip;
			this.orderSurfaceReceive = data.orderSurfaceReceive;
			this.orderSurfaceCarrier = data.orderSurfaceCarrier;
			this.orderSurfacePackageList = data.orderSurfacePackage.orderSurfacePackageItemList || [];
			this.orderSurfacePackage = data.orderSurfacePackage;
			this.opLogList = data.opLogList;
			this.otherInfo = {
				remark: data.remark,
				packingurl: data.packingurl,
				orginOrderId:data.orginOrderId
			};
			data.orderSurfacePackage.orderSurfacePackageItemList = undefined;
			this.getTrackingNo();
		},
		getDetail() {
			this.loading = true;
			HttpSfp({
				id: this.id
			}).then(
				res => {
					this.handleResponse(res.data);
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			);
		},
		printSfp() {
			this.handleWebfs(
				process.env.VUE_APP_APIURL_BOSS + "/api/v2/orderPackage/printed", {
					ids: this.id
				}, {
					executor: "request",
					print: true,
					fileType: "application/pdf"
				}
			).catch(err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},

		submitIgnoreSfp() {
			this.loading = true;
			HttpIgnoreSfp({
				id: this.id
			}).then(
				res => {
					this.handleGoback();
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			);
		},
		submitRetrySfp() {
			this.loading = true;
			HttpRetrySfp({
				id: this.id
			}).then(
				res => {
					this.handleGoback();
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			);
		},
		clearCalculate() {
			this.calculateList = [];
			this.isCalculated = false;
		},
		exchangeRateData(data) {
			data = { ...data };
			const rate = {
				'inch': 2.54,
				'lbs': 453.59237,
				'cm': 1,
				'g': 1
			},
				exchange = function (val = 0, type) {
					return Number(val * (rate[type] || 1)).toFixed(3);
				};
			['packedLength', 'packedWidth', 'packedHeight'].forEach(key => {
				data[key] = exchange(data[key], 'inch');
			});
			['packedWeight'].forEach(key => {
				data[key] = exchange(data[key], 'lbs');
			});
			return data;
		},
		async getTrackingNo() {
			if (!this.query) return;
			const { carrierCode, trackingNo } = this.orderSurfaceCarrier, sourceChannel = this.orderSurfaceInfo.sourceChannel;
			HttpSfpTrackingNo({ carrier: carrierCode, trackingCode: trackingNo, sourceChannel }).then(res => {
				this.trackingNoData = res.data || {};
			});
		},
		async getAddress(val) {
			HttpAllotAddress({ warehouseId: val }).then(res => {
				const { address, address2, city, state, country, postal, phone, mobilePhone, linkman, code } = res.data;
				this.orderSurfaceShip = {
					...this.orderSurfaceShip,
					// receiveStore: code,
					shipAddress: address,
					shipCity: city,
					shipState: state,
					shipCountry: country,
					shipPostal: postal,
					shipMobile: mobilePhone,
					shipContact: linkman
				}
			});
		},
		async validate() {
			const shipAddress = await this.$refs.shipAddress.validate();
			if (!shipAddress) {
				this.$VMessage.warning("请填写发货信息");
				return false;
			}
			if (this.isPushError) {
				const receiverAddress = await this.$refs.receiverAddress.validate();
				if (!receiverAddress) {
					this.$VMessage.warning("请填写发货信息");
					return false
				}
			}
			return true;
		},
		async submitCalculate() {
			const bool = await this.validate();
			if (!bool) return;
			const ref = this.$refs.packages, validate = await ref.validate();
			if (!validate) return this.$VMessage.warning("请填写包裹信息");
			this.loading = true;
			const formData = this.exchangeRateData(ref.formData);
			this.isSplit = formData.isSplit == 1;
			HttpCalculateSfp({
				id: this.id,
				orderSurfaceShip: this.orderSurfaceShip,
				orderSurfacePackage: formData
			}).then(
				res => {
					this.calculateList = res.data;
					this.loading = false;
					this.isCalculated = true;
				},
				err => {
					this.loading = this.isCalculated = false;
					this.calculateList = [];
					this.$VMessage.error({
						content: err.message,
						duration: 0
					});
				}
			);
		},
		async updateStatus() {
			this.loading = true;
			HttpUpdateSfpStatus({
				ids: this.id,
				status: 1
			}).then(
				res => {
					this.handleGoback();
					this.$VMessage.success(res.message);
				},
				err => {
					this.loading = false;
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			);
		},
		async confirmSubmit(type) {
			if (!this.isCalculated) {
				const bool = await this.validate();
				if (!bool) return;
			}
			const orderSurfaceCarrierList = Object.values(this.orderSurfaceCarrierList || []).filter(function (item) {
				return !!item;
			}),
				isError = this.orderSurfaceInfo.errorStatus == 3 || this.orderSurfaceInfo.errorStatus == 4;
			if (!orderSurfaceCarrierList.length && !isError) {
				this.$VModal.warning({
					title: "承运商及服务",
					content: "请点击运费测算并选择承运商，否则系统将自动选择预估运费最便宜的承运商去请求面单，请确认！"
				}, {
						'on-confirm': () => {
							this.submitSave(type, [])
						}
					})
				return;
			}
			if (isError) {
				this.submitSave(type, []);
				return;
			}
			this.submitSave(type, orderSurfaceCarrierList)
		},
		async submitSave(type, carrierList=[]) {
			this.loading = true;
			const orderSurfacePackage = this.exchangeRateData(this.$refs.packages.formData);
			HttpUpdateSfp({
				id: this.id,
				orderSurfaceShip: this.orderSurfaceShip,
				orderSurfaceReceive: this.orderSurfaceReceive,
				orderSurfacePackage,
				orderSurfaceCarrierList: carrierList,
				...this.otherInfo
			}).then(
				res => {
					if (type === 'buy'){
						this.updateStatus();
						return
					}
					if (type === 'retry'){
						this.submitRetrySfp();
						return
					}
					this.handleGoback();
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
				}
			);
		}
	}
};
</script>
